module.exports = __webpack_public_path__ + "static/media/coop.cf39594d.jpg";